import Vue from 'vue';
import Locations from '../apps/locations/index.vue';

const { locationAlert } = document.getElementById('location-alert').dataset;

const app = new Vue({
  el: '#locations',
  render(createElement) {
    return createElement(Locations, {
      props: {
        locationAlert: locationAlert === 'true',
      },
    });
  },
});
